import React, {useCallback, useEffect, useState} from 'react';
import Quiz from "../components/kozelDarkQuiz/Quiz";
import Banner from "../components/kozelDarkQuiz/Banner";
import Emoji from "../components/kozelDarkQuiz/Emoji";
import CinnamonArt from '../components/kozelDarkQuiz/CinnamonArt';
import Caravana from '../components/kozelDarkQuiz/Caravana';
import Photo from '../components/kozelDarkQuiz/Photo';

const KozelDarkQuiz : React.FC = () => {

    return  (
            <>
                <Banner/>
                <Quiz/>
                <CinnamonArt/>
                <Caravana/>
                <Emoji/>
                <Photo/>
            </>
        );
    };

export default KozelDarkQuiz;